import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AddressAttributeComponent } from './components/borrower-attributes/address-attribute/address-attribute.component';
import { AppRequirementCollapseComponent } from './components/app-requirement-collapse/app-requirement-collapse.component';
import { AppRequirementFormComponent } from './components/app-requirement-collapse/app-requirement-form/app-requirement-form.component';
import { AppRequirementsComponent } from './app-requirements.component';
import { BankRequirementsComponent } from './components/bank-requirements/bank-requirements.component';
import { BooleanAttributeComponent } from './components/borrower-attributes/boolean-attribute/boolean-attribute.component';
import { BorrowerAttributeComponent } from './components/borrower-attribute/borrower-attribute.component';
import { CurrencyAttributeComponent } from './components/borrower-attributes/currency-attribute/currency-attribute.component';
import { DateAttributeComponent } from './components/borrower-attributes/date-attribute/date-attribute.component';
import { MonthRequirementComponent } from './components/bank-requirements/month-requirement/month-requirement.component';
import { MultiselectAttributeComponent } from './components/borrower-attributes/multiselect-attribute/multiselect-attribute.component';
import { NumberAttributeComponent } from './components/borrower-attributes/number-attribute/number-attribute.component';
import { ProgressBarComponent } from 'app/components/progress-bar/progress-bar.component';
import { SelectAttributeComponent } from './components/borrower-attributes/select-attribute/select-attribute.component';
import { SsnAttributeComponent } from './components/borrower-attributes/ssn-attribute/ssn-attribute.component';
import { SubmitAppComponent } from './components/submit-app/submit-app.component';
import { TextAreaAttributeComponent } from './components/borrower-attributes/textarea-attribute/textarea-attribute.component';
import { TextAttributeComponent } from './components/borrower-attributes/text-attribute/text-attribute.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CollapsibleContainerModule } from 'ng2-app/borrower-fd/borrower-fd-sidebar/collapsible-container/collapsible-container.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
    declarations: [
        AddressAttributeComponent,
        AppRequirementCollapseComponent,
        AppRequirementFormComponent,
        AppRequirementsComponent,
        BankRequirementsComponent,
        BooleanAttributeComponent,
        BorrowerAttributeComponent,
        CurrencyAttributeComponent,
        DateAttributeComponent,
        MonthRequirementComponent,
        MultiselectAttributeComponent,
        NumberAttributeComponent,
        ProgressBarComponent,
        SelectAttributeComponent,
        SsnAttributeComponent,
        SubmitAppComponent,
        TextAreaAttributeComponent,
        TextAttributeComponent,
    ],
    exports: [
        AppRequirementsComponent,
    ],
    imports: [
      NgxMaskDirective,
        CollapsibleContainerModule,
        CommonModule,
        FormsModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatMenuModule,
    ],
  providers: [
    provideNgxMask(),
  ]
})
export class AppRequirementsModule { }
